<template>
  <form>
    <div class="input-group two-children">
      <input
        type="text"
        v-model="device.deviceNumber"
        placeholder="Device Number"
      />
      <RadioGroup
        :options="deviceTypes"
        :model="device.deviceType"
        @setValue="setDeviceType"
      />
    </div>

    <div class="input-group two-children">
      <input
        type="text"
        v-model="device.manufacturer"
        placeholder="Manufacturer (e.g. Apple)"
      />
      <input
        type="text"
        v-model="device.model"
        placeholder="Model (e.g. iPhone 6)"
      />
    </div>

    <div class="input-group two-children">
      <RadioGroup
        :options="osTypes"
        :model="device.os"
        @setValue="setOsType"
      />
      <input
        type="text"
        v-model="device.version"
        placeholder="OS Version"
      />
    </div>

    <div class="input-group two-children">
      <input
        type="text"
        v-model="device.modelNumber"
        placeholder="Model Number (e.g. MG612LL/A)"
      />
      <input
        type="text"
        v-model="device.serialNumber"
        placeholder="Serial Number (e.g. F78ND4Z8G5ML)"
      />
    </div>

    <div class="input-group two-children">
      <input
        type="text"
        v-model="device.notes"
        placeholder="Notes"
      />
      <input
        type="text"
        v-model="device.password"
        placeholder="Password"
      />
    </div>

    <div class="button-group primary-button-group">
      <div class="desktop-delete-button">
        <Button
          v-if="selectedDevice"
          :title="'Delete User'"
          :type="'flat'"
          :colorTheme="'warning'"
          @button-click="$emit('delete-device', device)"
        />
      </div>

      <div class="action-buttons">
        <Button
          :title="'Save'"
          :type="'raised'"
          :colorTheme="'primary'"
          @button-click="saveDevice"
        />
        <Button
          :title="'Cancel'"
          :type="'raised'"
          :colorTheme="'secondary'"
          @button-click="cancelForm"
        />
      </div>
    </div>

    <div class="button-group secondary-button-group" v-if="selectedDevice">
      <Button
        :title="'Delete Device'"
        :type="'flat'"
        :colorTheme="'warning'"
        @button-click="$emit('delete-device', device)"
      />
    </div>
  </form>
</template>

<script>
import Button from '@/components/form-elements/Button'
import RadioGroup from '@/components/form-elements/radio/RadioGroup';
import { deviceTypes, osTypes } from '@/constants/misc';

export default {
  name: "DeviceForm",
  components: {
    RadioGroup,
    Button
  },
  props: {
    selectedDevice: {
      required: false
    }
  },
  data() {
    if (this.selectedDevice) {
      return {
        device: this.selectedDevice,
        deviceTypes: deviceTypes,
        osTypes: osTypes
      }
    } else {
      return {
        device: {
          deviceNumber: '',
          deviceType: '',
          manufacturer: '',
          model: '',
          modelNumber: '',
          notes: '',
          os: '',
          password: '',
          serialNumber: '',
          version: ''
        },
        deviceTypes: deviceTypes,
        osTypes: osTypes
      }
    }
  },
  created() {
    if (this.selectedDevice) {
      this.deviceBeforeEdit = JSON.parse(JSON.stringify(this.selectedDevice))
    }
  },
  methods: {
    saveDevice() {
      this.$emit('save-device', this.device)
    },
    cancelForm() {
      Object.assign(this.device, this.deviceBeforeEdit)
      this.$emit('hide-dialog')
    },
    setDeviceType(type) {
      this.device.deviceType = type
    },
    setOsType(osType) {
      this.device.os = osType
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';
@import '../../assets/styles/card';

.input-group:last-child {
  border-bottom: 1px solid $primary-shadow;
}

@media (min-width: 600px) {
  .input-group:first-child {
    margin-bottom: 0;
  }
}

.card .button-group.primary-button-group {
  border-top: 1px solid $primary-shadow;
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceForm.vue